export default function Contact() {
  return (
    <section id="contact">
      <h2 style={{ fontSize: 36 }}>Contact</h2>

      <div className="glass" style={{ padding: 30, marginTop: 20 }}>
        <p>Email: shahdeveloper210@gmail.com</p>
        <p>LinkedIn: https://www.linkedin.com/in/shahpalak210/</p>
        <p>GitHub: github.com/palak</p>
      </div>
    </section>
  );
}